import {
  SET_LEAGUES_RESULT,
  SET_FILTER_LEAGUES,
  SET_FILTER_RESULTS,
  SET_HOT_LEAGUES,
  SET_ALL_LEAGUES,
  SET_HOT_LEAGUES_LOADING,
  SET_ALL_LEAGUES_LOADING,
  SET_HOT_LEAGUES_ERROR,
  SET_ALL_LEAGUES_ERROR
} from "./actionTypes";
import { RootState } from "../store";

interface LeagueState {
  league: {
    id: number;
    name: string;
  };
  filterLeagues?: any;
  filterResults?: any;
  hotLeagues: any[];
  allLeagues: any[];
  hotLeaguesLoading: boolean;
  allLeaguesLoading: boolean;
  hotLeaguesError: string | null;
  allLeaguesError: string | null;
}

const INITIAL_STATE: LeagueState = {
  league: {
    id: 0,
    name: 'Tất cả giải đấu'
  },
  hotLeagues: [],
  allLeagues: [],
  hotLeaguesLoading: false,
  allLeaguesLoading: false,
  hotLeaguesError: null,
  allLeaguesError: null,
};

const LeagueReducer = (state: LeagueState = INITIAL_STATE, action: any): LeagueState => {
  switch (action.type) {
    case SET_LEAGUES_RESULT:
      return {
        ...state,
        league: action.payload,
      };
    case SET_FILTER_LEAGUES:
      return { ...state, filterLeagues: action.payload };
    case SET_FILTER_RESULTS:
      return { ...state, filterResults: action.payload };
    case SET_HOT_LEAGUES:
      return {
        ...state,
        hotLeagues: action.payload,
      };
    case SET_ALL_LEAGUES:
      return {
        ...state,
        allLeagues: action.payload,
      };
    case SET_HOT_LEAGUES_LOADING:
      return {
        ...state,
        hotLeaguesLoading: action.payload,
      };
    case SET_ALL_LEAGUES_LOADING:
      return {
        ...state,
        allLeaguesLoading: action.payload,
      };
    case SET_HOT_LEAGUES_ERROR:
      return {
        ...state,
        hotLeaguesError: action.payload,
      };
    case SET_ALL_LEAGUES_ERROR:
      return {
        ...state,
        allLeaguesError: action.payload,
      };
    default:
      return state;
  }
};

export default LeagueReducer;
